import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import {
    LoadRecurrencesAction,
    AddRecurrenceAction,
    UpdateRecurrenceAction,
    DeleteRecurrenceAction
} from '@app/maintenance/store/maintenance.actions';
import { Recurrence } from '@app/shared/models/recurrence.model';
import { Store, select } from '@ngrx/store';
import { RecurrenceDetailsFormComponent } from '../../components/forms/recurrence-details-form/recurrence-details-form.component';

import * as MaintenanceReducer from "@app/maintenance/store/maintenance.reducer"

import { Subscription, Observable } from 'rxjs';
import { ConfirmationModalComponent } from '@app/shared/components';

@Component({
    selector: 'app-tool-maintenance-recurrences',
    templateUrl: './tool-maintenance-recurrences.component.html',
    styleUrls: ['./tool-maintenance-recurrences.component.scss']
})
export class ToolMaintenanceRecurrencesComponent implements OnInit, OnDestroy {

    @ViewChild(ConfirmationModalComponent, {static: true}) confirmationModal: ConfirmationModalComponent;


    isOpen = false;
    mode: string;
    recurrences = [];
    selectedRecurrence: Recurrence;
    toBeDeletedRecurrence: Recurrence;

    loading$: Observable<any>;
    recurrences$: Observable<any>;
    createdRecurrence$: Observable<any>;

    recurrencesSubscription: Subscription;
    createdRecurrenceSubscription: Subscription;

    private recurrenceDetailsForm: RecurrenceDetailsFormComponent;

    @ViewChild(RecurrenceDetailsFormComponent, {static: false}) set content(content: RecurrenceDetailsFormComponent) {
        if (content) {
            this.recurrenceDetailsForm = content;
        }
    }


    constructor(private store: Store<any>) {
        this.loading$ = this.store.pipe(select(MaintenanceReducer.isLoading));
        this.recurrences$ = this.store.pipe(select(MaintenanceReducer.getRecurrences));
        this.createdRecurrence$ = this.store.pipe(select(MaintenanceReducer.getCreatedRecurrence));

        this.recurrencesSubscription = this.recurrences$.subscribe(recurrences => {
            if (recurrences) {
                this.recurrences = recurrences.items;
            }
        });

        this.createdRecurrenceSubscription = this.createdRecurrence$.subscribe(createdRecurrence => {
            if (createdRecurrence) {
                this.selectedRecurrence = createdRecurrence;
                if (this.recurrenceDetailsForm) {
                    this.recurrenceDetailsForm.init(this.selectedRecurrence, 'edit');
                    this.isOpen = true;
                }
            }
        });
    }

    ngOnInit() {
        this.store.dispatch(new LoadRecurrencesAction());
    }

    openForm(mode: string) {
        this.isOpen = true;
    }

    onCreateRecurrence(recurrence: Recurrence) {
        this.store.dispatch(new AddRecurrenceAction(recurrence));
    }

    onEditRecurrence(recurrence: Recurrence) {
        this.store.dispatch(new UpdateRecurrenceAction(recurrence));
    }

    onDeleteRecurrence(recurrence: Recurrence) {
        this.toBeDeletedRecurrence = recurrence;
        this.confirmationModal.open();
    }

    onConfirmDeleteRecurrence() {
        this.isOpen = false;
        this.confirmationModal.close();
        this.store.dispatch(new DeleteRecurrenceAction(this.toBeDeletedRecurrence));
    }

    onCloseForm() {
        this.isOpen = false;
        this.selectedRecurrence = null;
    }

    onSearch(event: string) {
        this.store.dispatch(new LoadRecurrencesAction(event));
    }

    onSelectRecurrence(recurrence: Recurrence) {
        this.isOpen = true;
        this.selectedRecurrence = recurrence;
        setTimeout(() => this.recurrenceDetailsForm.init(recurrence, "edit"), 0);
    }

    onUnselectRecurrence(event: any) {
        this.selectedRecurrence = null;
        this.isOpen = false;
    }

    ngOnDestroy(): void {
        if (this.recurrencesSubscription) {
            this.recurrencesSubscription.unsubscribe();
        }

        if (this.createdRecurrenceSubscription) {
            this.createdRecurrenceSubscription.unsubscribe();
        }
    }
}
